module.exports = __webpack_public_path__ + "img/farming_1.fb233742.png";